export default "__VITE_ASSET__CeqFWCNA__"